import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation} from "../Univ.js";
function OpCaseSheet(props) {
    const {appt_id} = useParams();
    const [opcaseData, setOpcaseData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    const [labview, setLabView] = useState([]);
    const [invview, setInvView] = useState([]);
    const [hospData, setHospData] = useState([]);
    // ============================================================
    // FETCH OP CASE + HOSPITAL
    // ============================================================
    useEffect(() => {
        Promise.all([axios.get(baseUrl + "op-case/" + appt_id), axios.get(baseUrl + "view-hospital/" + userLocation + "/"),])
            .then(function (responses) {
                const opcaseResponse = responses[0];
                const hospitalResponse = responses[1];
                setOpcaseData(Array.isArray(opcaseResponse.data) ? opcaseResponse.data : []);
                setHospData(Array.isArray(hospitalResponse.data) ? hospitalResponse.data : []);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [appt_id]);
    // ============================================================
    // FETCH PHARMACY DATA
    // ============================================================
    useEffect(() => {
        if (!Array.isArray(opcaseData) || opcaseData.length === 0) {
            return;
        }
        const fetchPharmData = async () => {
            try {
                const allDrugIds = [];
                opcaseData.forEach((row) => {
                    if (!row.drug_id) {
                        return;
                    }
                    row.drug_id
                        .split(",")
                        .map((item) => item.trim())
                        .filter(Boolean)
                        .forEach((id) => {
                            if (!allDrugIds.includes(id)) {
                                allDrugIds.push(id);
                            }
                        });
                });
                const responses = await Promise.all(allDrugIds.map((id) => axios
                    .get(baseUrl + "update-indent-use/" + id + "/")
                    .then((response) => response.data)
                    .catch((error) => {
                        console.log(error);
                        return null;
                    })));
                setViewPharmData(responses.filter(Boolean));
            } catch (error) {
                console.log(error);
            }
        };
        fetchPharmData();
    }, [opcaseData]);
    // ============================================================
    // FETCH LAB
    // ============================================================
    useEffect(() => {
        if (!appt_id) {
            return;
        }
        axios
            .get(baseUrl + "view-lab-op/" + appt_id)
            .then((response) => {
                setLabView(Array.isArray(response.data) ? response.data : []);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [appt_id]);
    // ============================================================
    // FETCH RADIOLOGY / INVESTIGATION
    // ============================================================
    useEffect(() => {
        if (!appt_id) {
            return;
        }
        axios
            .get(baseUrl + "view-inv/" + appt_id)
            .then((response) => {
                setInvView(Array.isArray(response.data) ? response.data : []);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [appt_id]);
    // ============================================================
    // PRINT
    // ============================================================
    const handlePrint = () => {
        const printContents = document.getElementById("invoice-print").innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    // ============================================================
    // NO DATA
    // ============================================================
    if (!Array.isArray(opcaseData) || opcaseData.length === 0) {
        return (<section className="container mt-4">

            <div className="section-card">

                <div className="section-title">
                    OP Case Sheet
                </div>

                <div className="section-body">
                    No case sheet data available.
                </div>

            </div>

        </section>);
    }

    // ============================================================
    // RENDER
    // ============================================================
    return (<section className="container-fluid mt-4">

        <div id="invoice-print">

            {opcaseData.map((row, index) => {
                const consultant = row?.appt?.cons?.consultant || "";
                const department = row?.appt?.cons?.department || "";
                const patient = row?.appt?.pat || {};
                const profilePic = patient?.profile_pic || "";
                const visitDate = row?.add_date || "-";
                const visitTime = row?.appt?.appt_time || row?.appt?.appointment_time || row?.add_time || "-";
                const referred = patient?.refered || patient?.referred || row?.refered || row?.referred || "Walk-in";
                const relconsultant = patient?.refconsultant || patient?.refconsultant || row?.refconsultant || row?.refconsultant;
                return (<div
                    key={row.id || index}
                    className="op-case-sheet-print"
                >

{/* =================================================
    HOSPITAL HEADER
================================================= */}
<div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>
                    {/* =================================================
                                PATIENT INFORMATION
                            ================================================= */}

                    <div className="row ">

                        <div className="col-md-9">

                            <div className="section-card">

                                <div className="section-title">
                                    Patient Information
                                </div>

                                <div className="section-body">

                                    <div className="row">

                                        <div className="col-md-4">

                                            <div>
                                                        <span className="info-label">
                                                            Patient ID :
                                                        </span>{" "}
                                                {patient?.pat_id || "-"}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Patient Name :
                                                        </span>{" "}
                                                {patient?.my_title}&nbsp;
                                                {patient?.patient || "-"}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Age / Gender :
                                                        </span>{" "}
                                                {patient?.age || "-"}
                                                {" / "}
                                                {patient?.gender || "-"}
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <div>
                                                        <span className="info-label">
                                                            Mobile :
                                                        </span>{" "}
                                                {patient?.mobile || "-"}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Referred By :
                                                        </span>{" "}
                                                {referred}&nbsp;{relconsultant}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Consultant :
                                                        </span>{" "}
                                                {consultant ? `Dr. ${consultant}` : "-"}
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <div>
                                                        <span className="info-label">
                                                            Visit Date :
                                                        </span>{" "}
                                                {visitDate}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Visit Time :
                                                        </span>{" "}
                                                {visitTime}
                                            </div>

                                            <div>
                                                        <span className="info-label">
                                                            Department :
                                                        </span>{" "}
                                                {department || "-"}
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* =================================================
                                    PROFILE PHOTO
                                ================================================= */}

                        <div className="col-md-3">

                            <div
                                className="section-card"
                                style={{
                                    height: "100%", display: "flex", alignItems: "center", justifyContent: "center"
                                }}
                            >

                                {profilePic ? (<img
                                    src={profilePic}
                                    alt="Patient"
                                    style={{
                                        width: "110px",
                                        height: "130px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd"
                                    }}
                                />) : (<div
                                    style={{
                                        width: "110px",
                                        height: "130px",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#999",
                                        fontSize: "12px"
                                    }}
                                >
                                    No Photo
                                </div>)}

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                                VITALS - SINGLE ROW
                            ================================================= */}

                    <div className="section-card">

                        <div className="section-title">
                            Vitals
                        </div>

                        <div
                            className="section-body"
                            style={{
                                display: "flex", flexWrap: "wrap", gap: "30px", alignItems: "center"
                            }}
                        >

                            <div>
                                        <span className="info-label">
                                            Weight :
                                        </span>{" "}
                                {row.weight || "-"} Kg
                            </div>

                            <div>
                                        <span className="info-label">
                                            Height :
                                        </span>{" "}
                                {row.height || "-"} Cm
                            </div>

                            <div>
                                        <span className="info-label">
                                            BMI :
                                        </span>{" "}
                                {row.bmi || "-"}
                            </div>

                            <div>
                                        <span className="info-label">
                                            BP :
                                        </span>{" "}
                                {row.bp || "-"}
                            </div>

                            <div>
                                        <span className="info-label">
                                            Pulse :
                                        </span>{" "}
                                {row.pulse || "-"}
                            </div>

                            <div>
                                        <span className="info-label">
                                            Temperature :
                                        </span>{" "}
                                {row.tempr || "-"}
                            </div>

                            <div>
                                        <span className="info-label">
                                            SPO2 :
                                        </span>{" "}
                                {row.spo2 || "-"}
                            </div>

                        </div>

                    </div>


                    {/* =================================================
    CLINICAL NOTES & EXAMINATION / HISTORY
================================================= */}

                    <div className="row clinical-history-print">

                        {/* =================================================
        CLINICAL NOTES
    ================================================= */}

                        <div className="col-lg-6 col-md-12 mb-3">

                            <div className="section-card clinical-section">

                                <div className="section-title">
                                    Clinical Notes
                                </div>

                                <div className="section-body clinical-section-body">

                                    <div className="row g-3">

                                        {/* =================================================
                        DYNAMIC DEPARTMENT DATA
                    ================================================= */}

                                        {row.department_data && typeof row.department_data === "object" && Object.entries(row.department_data).map(([name, value]) => {
                                            if (value === null || value === undefined || value === "") {
                                                return null;
                                            }
                                            return (<div
                                                className="col-md-6"
                                                key={name}
                                            >

                                                <div className="history-item">

                                                    <b>
                                                        {name
                                                            .replace(/_/g, " ")
                                                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                                                    </b>

                                                    <div>
                                                        {String(value)}
                                                    </div>

                                                </div>

                                            </div>);
                                        })}


                                        {/* =================================================
                        MEDICAL HISTORY
                    ================================================= */}

                                        {row.illness && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    P / Medical H/O
                                                </b>

                                                <div>
                                                    {row.illness}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        SURGICAL HISTORY
                    ================================================= */}

                                        {row.complaints && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    P / Surgical H/O
                                                </b>

                                                <div>
                                                    {row.complaints}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        ALLERGY
                    ================================================= */}

                                        {row.allergy && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Allergy
                                                </b>

                                                <div>
                                                    {row.allergy}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        INVESTIGATIONS / IMAGING
                    ================================================= */}

                                        {row.diet && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Investigations / Imaging
                                                </b>

                                                <div>
                                                    {row.diet}
                                                </div>

                                            </div>

                                        </div>)}

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* =================================================
        EXAMINATION & HISTORY
    ================================================= */}

                        <div className="col-lg-6 col-md-12 mb-3">

                            <div className="section-card clinical-section">

                                <div className="section-title">
                                    Examination & History
                                </div>

                                <div className="section-body clinical-section-body">

                                    <div className="row g-3">

                                        {/* =================================================
                        DIAGNOSIS
                    ================================================= */}

                                        {row.diagnosis && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Diagnosis
                                                </b>

                                                <div>
                                                    {row.diagnosis}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        TREATMENT / PLAN
                    ================================================= */}

                                        {row.tsugg && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Treatment / Plan
                                                </b>

                                                <div>
                                                    {row.tsugg}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        ADVISE
                    ================================================= */}

                                        {row.tadvise && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Advise
                                                </b>

                                                <div>
                                                    {row.tadvise}
                                                </div>

                                            </div>

                                        </div>)}


                                        {/* =================================================
                        OPINION / REFERRAL
                    ================================================= */}

                                        {row.physio && (<div className="col-md-6">

                                            <div className="history-item">

                                                <b>
                                                    Opinion / Referral
                                                </b>

                                                <div>
                                                    {row.physio}
                                                </div>

                                            </div>

                                        </div>)}

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* =================================================
                                EYE DEPARTMENT
                            ================================================= */}

                    {department === "EYE" && (<div className="section-card mt-4">

                        <div className="section-title">
                            Eye Examination
                        </div>

                        <div className="section-body">

                            <div className="row">

                                <div className="col-md-6">

                                    <div>ARD : {row.ard || "-"}</div>
                                    <div>ARS : {row.ars || "-"}</div>
                                    <div>K1d : {row.k1d || "-"}</div>
                                    <div>K1s : {row.k1s || "-"}</div>

                                </div>

                                <div className="col-md-6">

                                    <div>K2d : {row.k2d || "-"}</div>
                                    <div>K2s : {row.k2s || "-"}</div>
                                    <div>PTD : {row.ptd || "-"}</div>
                                    <div>PTS : {row.pts || "-"}</div>

                                </div>

                            </div>

                            <hr/>

                            <div className="row">

                                <div className="col-md-6">

                                    <div>
                                        VNUD : {row.vnud || "-"}
                                    </div>

                                    <div>
                                        VNUS : {row.vnus || "-"}
                                    </div>

                                    <div>
                                        VNPD : {row.vnpd || "-"}
                                    </div>

                                    <div>
                                        VNPS : {row.vnps || "-"}
                                    </div>

                                </div>

                                <div className="col-md-6">

                                    <div>
                                        PGD : {row.pgd || "-"}
                                    </div>

                                    <div>
                                        PGS : {row.pgs || "-"}
                                    </div>

                                    <div>
                                        Subjectived :{" "}
                                        {row.subjectived || "-"}
                                    </div>

                                    <div>
                                        Subjectives :{" "}
                                        {row.subjectives || "-"}
                                    </div>

                                </div>

                            </div>

                            <hr/>

                            <div className="row">

                                <div className="col-md-6">

                                    <div>
                                        Pupild : {row.pupild || "-"}
                                    </div>

                                    <div>
                                        Pupils : {row.pupils || "-"}
                                    </div>

                                    <div>
                                        Cyclod : {row.cyclod || "-"}
                                    </div>

                                    <div>
                                        Cyclos : {row.cyclos || "-"}
                                    </div>

                                </div>

                                <div className="col-md-6">

                                    <div>
                                        Remarkd : {row.remarkd || "-"}
                                    </div>

                                    <div>
                                        Remarks : {row.remarkss || "-"}
                                    </div>

                                    <div>
                                        EOMD : {row.eomd || "-"}
                                    </div>

                                    <div>
                                        EOMS : {row.eoms || "-"}
                                    </div>

                                </div>

                            </div>

                            <hr/>

                            <div className="row">

                                <div className="col-md-6">

                                    <div>
                                        SLED : {row.sled || "-"}
                                    </div>

                                    <div>
                                        SLES : {row.sles || "-"}
                                    </div>

                                </div>

                                <div className="col-md-6">

                                    <div>
                                        ATD : {row.atd || "-"}
                                    </div>

                                    <div>
                                        ATS : {row.ats || "-"}
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>)}


                    {/* =================================================
                                PRESCRIPTION
                            ================================================= */}

                    {row.drug_id && (<div className="table-responsive">

                        <table className="erp-table-modern">

                            <thead>

                            <tr
                                style={{
                                    backgroundColor: "#1bc5ce", color: "white"
                                }}
                            >

                                <th>
                                    Rx No
                                </th>

                                <th>
                                    Medicine
                                </th>

                                <th>
                                    Dose
                                </th>
                                <th>
                                    Usage
                                </th>
                                <th>
                                    Days
                                </th>
                                <th>
                                    Qty
                                </th>

                                <th>
                                    Instructions
                                </th>

                            </tr>

                            </thead>

                            <tbody>
                            {row.drug_id?.split(",").map((test, i) => {
                                const drugId = test.trim();
                                const pharmData = viewPharmData.find((data) => String(data.id) === String(drugId));
                                const ddays = row.ddays?.split(",")[i]?.trim() || "-";
                                const dnotes = row.dnotes?.split(",")[i]?.trim() || "-";
                                const dose = row.dose?.split(",")[i]?.trim() || "-";
                                const freq = row.freq?.split(",")[i]?.trim() || "-";
                                const remarks = row.remarks?.split(",")[i]?.trim() || "-";
                                return (<tr key={`${row.id}-${drugId}-${i}`}>

                                    {/* Rx No */}
                                    <td>
                                        {drugId}
                                    </td>

                                    {/* Medicine */}
                                    <td>
                                        {pharmData?.product_name || "-"}
                                    </td>

                                    {/* Dose */}

                                    {/* Instructions */}
                                    <td>
                                        {remarks}
                                    </td>

                                    {/* Frequency */}
                                    <td>
                                        {freq}
                                    </td>
                                    <td>
                                        {ddays}
                                    </td>
                                    <td>
                                        {dose}
                                    </td>
                                    <td>
                                        {dnotes}
                                    </td>

                                </tr>);
                            })}
                            </tbody>

                        </table>

                    </div>)}


                    {/* =================================================
                                LAB + RADIOLOGY / INVESTIGATION
                            ================================================= */}

                    {(labview.length > 0 || invview.length > 0) && (<div className="table-responsive">

                        <table className="erp-table-modern">

                            <thead>

                            <tr
                                style={{
                                    backgroundColor: "#1bc5ce", color: "white"
                                }}
                            >

                                <th
                                    style={{
                                        width: "120px"
                                    }}
                                >
                                    Type
                                </th>

                                <th>
                                    Investigation / Test Name
                                </th>

                            </tr>

                            </thead>

                            <tbody>

                            {/* LAB */}

                            {labview.map((labviewData, index) => (<tr
                                key={`lab-${index}`}
                            >

                                <td>
                                                            <span className="badge bg-primary">
                                                                Laboratory
                                                            </span>
                                </td>

                                <td>

                                    {labviewData?.lab_test
                                        ?.split(",")
                                        .map((test, i) => (<span
                                            key={i}
                                            style={{
                                                marginRight: "18px"
                                            }}
                                        >
                                                                            {test.trim()}
                                                                        </span>))}

                                </td>

                            </tr>))}


                            {/* RADIOLOGY / INVESTIGATION */}

                            {invview.map((invviewData, index) => (<tr
                                key={`radiology-${index}`}
                            >

                                <td>
                                                            <span className="badge bg-warning text-dark">
                                                                Radiology
                                                            </span>
                                </td>

                                <td>

                                    {invviewData?.inv_test
                                        ?.split(",")
                                        .map((test, i) => (<span
                                            key={i}
                                            style={{
                                                marginRight: "18px"
                                            }}
                                        >
                                                                            {test.trim()}
                                                                        </span>))}

                                </td>

                            </tr>))}

                            </tbody>

                        </table>

                    </div>)}
                    {/* =================================================
    PATIENT TYPE + REVIEW / CONSULTANT SIGNATURE
================================================= */}

                    <div
                        className="row mt-3"
                        style={{
                            pageBreakInside: "avoid"
                        }}
                    >
                        {/* =================================================
        LEFT : PATIENT TYPE
    ================================================= */}

                        <div
                            className="col-md-6"
                            style={{
                                textAlign: "center"
                            }}
                        >
                            {row?.pat_type && (<>

                                {row.pat_type !== "Normal" && (<img
                                    src={row.pat_type === "Penis Meatus" ? "/Penis Meatus.jpeg" : row.pat_type === "Abdomen" ? "/Abdomen.jpeg" : row.pat_type === "Testis" ? "/Testis.jpeg" : row.pat_type === "Kidney" ? "/Kidney.jpeg" : null}
                                    alt={row.pat_type || ""}
                                    style={{
                                        width: "500px",
                                        height: "200px",
                                        objectFit: "contain",
                                        display: "block",
                                        margin: "0 auto 5px auto"
                                    }}
                                />)}

                            </>)}
                        </div>


                        {/* =================================================
        RIGHT : REVIEW DATE + CONSULTANT
    ================================================= */}

                        <div
                            className="col-md-6"
                            style={{
                                textAlign: "center"
                            }}
                        >
                            {/* Next Review Date */}
                            <div
                                style={{
                                    marginBottom: "20px", fontSize: "14px"
                                }}
                            >
                                <strong>
                                    Next Review Date :{" "}
                                </strong>

                                {row?.review_date ? new Date(row.review_date + "T00:00:00").toLocaleDateString("en-GB") : "-"}
                            </div>


                            {/* Consultant Signature */}
                            <img src={`/${consultant}.jpeg`}
                                 alt="Consultant Signature"
                                 style={{
                                     width: "150px",
                                     height: "70px",
                                     objectFit: "contain",
                                     display: "block",
                                     margin: "0 auto 5px auto"
                                 }}
                            />

                            <div
                                style={{
                                    borderTop: "1px solid #000",
                                    paddingTop: "6px",
                                    display: "inline-block",
                                    minWidth: "220px"
                                }}
                            >
                                <strong>
                                    Dr. {consultant}
                                </strong>

                                {department && (<>
                                    <br/>
                                    {department}
                                </>)}
                            </div>
                        </div>
                    </div>
                    {/* =================================================
                                END OF CASE SHEET
                            ================================================= */}

                    <div
                        className="text-center mt-5"
                        style={{
                            borderTop: "1px solid #ccc", paddingTop: "10px", fontSize: "12px"
                        }}
                    >

                        *** End of Case Sheet ***

                    </div>

                </div>);
            })}

        </div>


        {/* =================================================
                PRINT BUTTON
            ================================================= */}

        <div
            className="mt-5 mb-5"
            style={{
                display: "flex", justifyContent: "center", alignItems: "center"
            }}
        >

            <button
                type="button"
                className="btn btn-primary"
                style={{
                    padding: "6px 25px", borderRadius: "10px"
                }}
                onClick={handlePrint}
            >
                Print
            </button>

        </div>

    </section>);
}
export default OpCaseSheet;
